import React, { memo } from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { HomeTabsParams } from "./HomeTabParams";
import {
  ProfileStackRoute,
  WelcomeRoute,
  WellBeingRoute,
  LogoutRoute,
  MoreOptionsRoute,
  WalletStackRoute,
} from "./routes";
import WellBeing from "../../screens/WellBeing";
import { useTheme } from "../../theme/colors";
import { View } from "react-native";
import ProfileIcon from "../../Icons/ProfileIcon";
import ProfileStack from "../ProfileStack/ProfileStack";
import { Frame, IsMobile } from "../../theme";
import { useAppContext } from "../../contexts/AppContext";
import WB from "../../Icons/WB";
import MH from "../../Icons/MH";
import Chat from "../../screens/Chat";
import ChatIcon from "../../Icons/ChatIcon";
import { DeleteScreenRoute, ShareScreenRoute } from "../ProfileStack/routes";
import WelcomeScreen from "../../screens/WelcomeScreen/WelcomeScreen";
import { CircumstancesType } from "../../constants";
import LogoutScreen from "../../screens/LogoutScreen/LogoutScreen";
import MoreOptionsSvgIcon from "../../Icons/MoreOptionsIcon";
import MoreOptionsScreen from "../../screens/MoreOptions/MoreOptionsScreen";
import WalletIcon from "../../Icons/WalletIcon";
import WalletStack from "../WalletStack/WalletStack";
import LogoutIcon from "../../Icons/LogoutIcon";
import {WEB_MAXWIDTH} from "../../../constants";

const { Navigator, Screen } = createBottomTabNavigator<HomeTabsParams>();

interface IconProps {
  variant: CircumstancesType;
  focused: Boolean;
}

const Icon = memo<IconProps>(({ variant, focused }) => {
  const theme = useTheme();
  if (variant === CircumstancesType.WELLBEING)
    return <WB color={focused ? theme.ACCENT : theme.LIGHT_GREY} />;
  return <MH color={focused ? theme.ACCENT : theme.LIGHT_GREY} />;
});

const HomeTabs = () => {
  const { mode } = useAppContext();
  const theme = useTheme();

  return (
    <Navigator
      screenOptions={{
        tabBarStyle: IsMobile
          ? {
              backgroundColor: theme.BACKGROUND,
            }
          : { width: WEB_MAXWIDTH, alignSelf: "center" },
        headerShown: false,
        tabBarHideOnKeyboard: true,
      }}
    >
      <Screen
        options={{
          title: mode,
          tabBarIcon: ({ focused }) => null,
          tabBarLabel: () => null,
          tabBarButton: () => null,
        }}
        name={WelcomeRoute}
        component={WelcomeScreen}
      />
      <Screen
        options={{
          title: mode,
          tabBarIcon: ({ focused }) => (
            <Icon variant={CircumstancesType.WELLBEING} focused={focused} />
          ),
          tabBarLabel: () => null,
          unmountOnBlur: true,
        }}
        name={WellBeingRoute}
        component={WellBeing}
      />
      <Screen
        options={{
          title: "Chat",
          tabBarIcon: ({ focused }) => (
            <View>
              <ChatIcon
                color={focused ? theme.ACCENT : theme.LIGHT_GREY}
                width={23}
                height={23}
              />
            </View>
          ),
          tabBarLabel: () => null,
        }}
        name={"Chat"}
        component={Chat}
      />
      <Screen
        options={{
          title: "Wallet",
          tabBarIcon: ({ focused }) => (
            <View>
              <WalletIcon
                color={focused ? theme.ACCENT : theme.LIGHT_GREY}
                width={23}
                height={23}
              />
            </View>
          ),
          tabBarLabel: () => null,
        }}
        name={WalletStackRoute}
        component={WalletStack}
      />
      <Screen
        options={({ route, navigation }) => {
          const isShareScreen =
            navigation
              .getState()
              .routes.find((route: any) => route.name === ProfileStackRoute)
              ?.params?.screen === ShareScreenRoute;

          const isDeleteUserScreen =
            navigation
              .getState()
              .routes.find((route: any) => route.name === ProfileStackRoute)
              ?.params?.screen === DeleteScreenRoute;

          return {
            title: "Profile",
            tabBarIcon: ({ focused }) => (
              <View
                style={[IsMobile ? { marginLeft: -5 } : { marginLeft: -25 }]}
              >
                <ProfileIcon
                  color={
                    focused && !isShareScreen && !isDeleteUserScreen
                      ? theme.ACCENT
                      : theme.LIGHT_GREY
                  }
                />
              </View>
            ),
            tabBarLabel: ({ focused }) => (focused ? null : null),
          };
        }}
        name={ProfileStackRoute}
        component={ProfileStack}
      />
      <Screen
        options={{
          title: "Logout",
          tabBarIcon: ({ focused }) => (
            <View>
              <LogoutIcon color={focused ? theme.ACCENT : theme.LIGHT_GREY} />
            </View>
          ),
          tabBarLabel: () => null,
        }}
        name={LogoutRoute}
        component={LogoutScreen}
      />

      {/* <Screen
        options={{
          tabBarButton: () => null,
        }}
        name={LogoutRoute}
        component={LogoutScreen}
      /> */}
    </Navigator>
  );
};

export default HomeTabs;
